import PropTypes from 'prop-types';
import localData from 'utils/localData';
import { USER_COMMENT } from 'shared/constants/comment';
import { resolveComponent } from './config/componentRegistry';
import logger from 'utils/logger';

const propTypes = {
  analyticData: PropTypes.object.isRequired,
  fetchData: PropTypes.func.isRequired,
  issue: PropTypes.object.isRequired,
  fetchStatus: PropTypes.func.isRequired,
  rerunDataAnalysis: PropTypes.func.isRequired,
};

const log = logger.createLogger('AIAnalysis');

/**
 * Main AI Analysis Component with Modular Layout System
 *
 * This component uses a modular routing system to determine the appropriate
 * layout based on organization and tag combinations. The system is designed to be:
 * - Easily extensible for new organizations and tags
 * - Maintainable with clear separation of concerns
 * - Performant with component-level code splitting potential
 */
const AIAnalysis = ({
  analyticData,
  fetchData,
  fetchStatus,
  issue,
  rerunDataAnalysis,
}) => {
  // Get current organization ID from local storage
  const currentOrganizationId = localData.get(USER_COMMENT.CURRENT_ORGID);

  // Resolve the appropriate component based on issue context
  const ResolvedComponent = resolveComponent({
    issue,
    currentOrganizationId,
  });

  log.debug('analyticData', analyticData);

  // Render the resolved component with all original props
  return (
    <ResolvedComponent
      analyticData={analyticData}
      fetchData={fetchData}
      fetchStatus={fetchStatus}
      issue={issue}
      rerunDataAnalysis={rerunDataAnalysis}
    />
  );
};

AIAnalysis.propTypes = propTypes;

export default AIAnalysis;
